<template>
  <div class="row d-flex justify-content-center">
    <div class="col-md-8 mr-auto ml-auto">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 mr-auto ml-auto">
              <h4 class="card-title text-center">ขอบคุณสำหรับการสั่งซื้อ</h4>
              <h4 class="card-title text-center">
                หมายเลขคำสั่งซื้อของท่านคือ <strong>{{ data.orderNo }}</strong>
              </h4>
              <div class="row">
                <div class="col-md-12 text-center">
                  <img
                    src="https://rmsonsmaster.s3.ap-southeast-1.amazonaws.com/LineQr.png"
                    alt="line qr code"
                    width="250px;"
                  />
                </div>
              </div>
              <div class="text-center">
                <a href="https://lin.ee/hYaMeFJ"
                  ><img
                    src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png"
                    alt="เพิ่มเพื่อน"
                    height="50"
                    border="0"
                /></a>
              </div>
              <h5 class="card-title text-center" style="margin-top: 10px">
                โปรดแอด Line OA ของทางร้านเพื่อติดตามคำสั่งซื้อของท่าน
              </h5>
              <h5 class="card-title text-center">
                เจ้าหน้าที่จะติดต่อท่านไป เมื่อดำเนินการเติมเกมสำเร็จ
              </h5>
              <div class="text-center">
                <n-button class="btn-default" size="lg" @click="onClose">
                  ปิด
                </n-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClose() {
      localStorage.removeItem("AcceptTerm");
      localStorage.removeItem("IsConfirm");
      localStorage.removeItem("GamePackage");
      localStorage.removeItem("data");
      this.$router.push("/game");
    },
  },
  data() {
    return {
      data: null,
    };
  },
  beforeMount() {
    var data = JSON.parse(localStorage.getItem("data"));
    this.data = data;

    localStorage.removeItem("AcceptTerm");
    localStorage.removeItem("IsConfirm");
  },
};
</script>

<style>
</style>